import face01 from 'assets/images/website/face-01.jpg';

import face02 from 'assets/images/website/face-02.jpg';
import face03 from 'assets/images/website/face-03.jpg';
import face04 from 'assets/images/website/face-04.jpg';
import face05 from 'assets/images/website/face-05.jpg';
import type { FunctionComponent } from 'react';

import './style.scss';

const FiveFaces: FunctionComponent = () => (
  <div styleName="container">
    <img alt="Portrait05" src={face05} styleName="face face05" />
    <img alt="Portrait01" src={face01} styleName="face face01" />
    <img alt="Portrait02" src={face02} styleName="face face02" />
    <img alt="Portrait03" src={face03} styleName="face face03" />
    <img alt="Portrait04" src={face04} styleName="face face04" />
  </div>
);

export default FiveFaces;
